import DeleteIcon from "@mui/icons-material/Delete"
import { Autocomplete, Box, Button, FormControlLabel, Grid, Paper, Radio, RadioGroup, Switch, Table, TableBody, TableCell, TableHead, TableRow, TextField } from "@mui/material"
import { isEmpty, isNil } from "lodash"
import { useEffect, useState } from "react"
import { BaseSettings, SettingsPickBanEasy, SettingsPickBanHard, TournoiFrancophoneSettingDto } from "./SettingsPickBanS3"
import { PickBanChoiceDto, TurnPickBanDto } from "./TurnPickBanDto"

export const PickBanScreen = () => {

    let [joueur1, setJoueur1] = useState("")
    let [joueur2, setJoueur2] = useState("")


    let [pickBanStart, setPickBanStart] = useState(false);
    let [hardSetting, setHardSetting] = useState(false)

    let [pickBanList, setPickBanList] = useState<Array<PickBanChoiceDto>>([])

    let [hideInformation, setHideInformation] = useState(false);
    let [currentSettingsSelection, setCurrentSettingsSelection] = useState<TournoiFrancophoneSettingDto | null>(null)
    let [currentPickBan, setCurrentPickBan] = useState<"pick" | "ban" | null>()

    let [turn, setTurn] = useState(1);

    let sequencePickBan: Array<TurnPickBanDto> = [
        { joueur: joueur1, choice: "ban" },
        { joueur: joueur2, choice: "ban" },
        { joueur: joueur1, choice: "both" },
        { joueur: joueur2, choice: "both" },
        { joueur: joueur2, choice: "both" },
        { joueur: joueur1, choice: "both" },
        { joueur: joueur1, choice: "both" },
        { joueur: joueur2, choice: "both" },
    ]


    const addChoice = () => {
        if (isNil(currentPickBan) || isNil(currentSettingsSelection))
            return;

        let newChoice: PickBanChoiceDto = {
            choice: currentPickBan,
            joueur: sequencePickBan[turn - 1].joueur,
            setting: currentSettingsSelection,
            turn: turn
        }

        setPickBanList([...pickBanList ?? [], newChoice])

        setCurrentPickBan(null)
        setCurrentSettingsSelection(null)

        if (turn + 1 > 10) {
            setTurn(1)
            setPickBanStart(false);
        }
        setTurn(turn + 1)


    }

    const cancelLastTurn = () => {
        pickBanList.splice(pickBanList.length - 1)
        setPickBanList(pickBanList)
        setTurn(turn - 1)
    }

    useEffect(() => {
        if (pickBanStart) {
            if (sequencePickBan[turn - 1].choice === "pick" && currentPickBan !== "pick")
                setCurrentPickBan("pick")
            else if (sequencePickBan[turn - 1].choice === "ban" && currentPickBan !== "ban")
                setCurrentPickBan("ban")
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [turn, currentPickBan, pickBanStart])


    return <Grid container spacing={2}>
        <Grid item container xs={12} direction="row" component={Paper} padding={"10px"} margin="10px">
            <Grid item xs={2} />
            <Grid item xs={2}>
                <TextField
                    value={joueur1}
                    label="Joueur 1"
                    onChange={(e) => setJoueur1(e.currentTarget.value)}
                    disabled={pickBanStart}
                    size="small"
                />
            </Grid>

            <Grid item xs={2}>
                <TextField
                    value={joueur2}
                    label="Joueur 2"
                    onChange={(e) => setJoueur2(e.currentTarget.value)}
                    disabled={pickBanStart}
                    size="small"
                />
            </Grid>
            <Grid item xs={2}>
                <FormControlLabel
                    value="start"
                    control={<Switch color="primary" />}
                    label="Hard Settings"
                    labelPlacement="end"
                    disabled={pickBanStart}
                    onChange={(e, v) => setHardSetting(v)}
                />
            </Grid>
            <Grid item xs={2}>
                {pickBanStart && <Button onClick={() => { setHideInformation(!hideInformation) }}>{hideInformation ? "Hide" : "Show"} Rules / App Explanation</Button>}
            </Grid>
            <Grid item xs={2}>
                <Button color="success" sx={{ border: "1px solid" }} onClick={(e) => setPickBanStart(true)} disabled={isEmpty(joueur1) || isEmpty(joueur2) || pickBanStart}>Start Pick / Ban phase</Button>
            </Grid>

            {(isEmpty(joueur1) || isEmpty(joueur2)) && <Grid item xs={12}>
                <Box color="red" textAlign={"center"}>The two players name must be filled</Box>
            </Grid>}
        </Grid>

        {pickBanStart && hideInformation && <Grid item xs={12}>

            <Box component="p" textAlign={"center"}>Each turn a player must made a Pick or a Ban (The ban is mandatory for the first turn of each player) <br />
                By <Box component="span" color="red">Banning</Box> a setting, the setting can't be picked by your adversary. It doesn't change the current ruleset <br />
                By <Box component="span" color="green">Picking</Box> a setting , it will be added to the ruleset. If the rule is in conflict with a Base rule, the base rule is replace bu the picked rule. <br />
                If the rule picked can be in conflict with other pickable settings, the other settings are removed from the players choice. i.e :<br />
                Picking Song Anywhere remove Dungeon Reward Song <br />
                Picking a Bridge requirement remove other bridge requirement settings

            </Box>
        </Grid>}
        {!pickBanStart && !isEmpty(pickBanList) && <Grid item xs={12}>
            Rules of the race
            <br />
            Base Tournoi Francophone
            <br />
            {"without " + BaseSettings.filter(x => pickBanList.some(bs => bs.setting.nullifySetting?.some(y => y === x.id) && bs.choice === "pick")).map(m => m.title).join(", ")}
            <br />
            Pick : {pickBanList.filter(x => x.choice === "pick").map(p => p.setting.title).join(", ")}
        </Grid>
        }
        {pickBanStart && <Grid container item xs={12} component={Paper} padding={"10px"} margin="10px" spacing={2}>
            <Grid item container xs={12} justifyContent={"center"}>
                <Box component="h2">Turn #{turn} : <Box color="green" component="span">{sequencePickBan[turn - 1].joueur}</Box> must {sequencePickBan[turn - 1].choice === "both" ? <Box component="span"><Box component="span" color="green">Pick</Box> or <Box component="span" color="red">Ban</Box> </Box> : sequencePickBan[turn - 1].choice === "pick" ? <Box color="green" component="span">Pick</Box> : <Box color="red" component="span">Ban</Box>} a settings</Box>
            </Grid>
            <Grid item xs={2} />
            <Grid item container xs={2}>
                <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="female"
                    name="radio-buttons-group"
                >
                    <FormControlLabel value="pick" control={<Radio />} label="Pick" onClick={(e) => setCurrentPickBan("pick")} checked={currentPickBan === "pick"} disabled={sequencePickBan[turn - 1].choice === "ban"} />
                    <FormControlLabel value="ban" control={<Radio />} checked={currentPickBan === "ban"} label="Ban" onClick={(e) => setCurrentPickBan("ban")} disabled={sequencePickBan[turn - 1].choice === "pick"} />
                </RadioGroup>
            </Grid>
            {hardSetting && <Grid item container xs={6} justifyContent={"stretch"} spacing={2}>
                <Grid item xs={6} justifyContent={"stretch"}>
                    <Autocomplete
                        options={SettingsPickBanEasy.filter(x => !pickBanList.some(l => l.setting.disableSetting?.some(d => d === x.id) || l.setting.id === x.id))}
                        getOptionLabel={(option) => option.title}
                        value={currentSettingsSelection}
                        onChange={(e, v) => setCurrentSettingsSelection(v)}
                        renderInput={(props) => <TextField {...props} label="Classic Settings" />}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={6} justifyContent={"stretch"}>
                    <Autocomplete
                        options={SettingsPickBanHard.filter(x => !pickBanList.some(l => l.setting.disableSetting?.some(d => d === x.id) || l.setting.id === x.id))}
                        getOptionLabel={(option) => option.title}
                        value={currentSettingsSelection}
                        onChange={(e, v) => setCurrentSettingsSelection(v)}
                        renderInput={(props) => <TextField {...props} label="Hard Settings" />}
                        fullWidth
                    />
                </Grid>
                {/* <Grid item xs={6}>Bridge Requirement number</Grid>
                <Grid item xs={3}>Ganon BossKey Requirement</Grid>
                <Grid item xs={3}>Ganon Boss Key requirement number</Grid> */}
            </Grid>}

            {!hardSetting && <Grid item xs={6}>
                <Autocomplete
                    options={SettingsPickBanEasy.filter(x => !pickBanList.some(l => l.setting.disableSetting?.some(d => d === x.id) || l.setting.id === x.id))}
                    getOptionLabel={(option) => option.title}
                    value={currentSettingsSelection}
                    onChange={(e, v) => setCurrentSettingsSelection(v)}
                    renderInput={(props) => <TextField {...props} label="Classic Settings" />}
                    fullWidth
                />


            </Grid>}

            <Grid item xs={2} >
                <Button color={"success"} sx={{ border: "1px solid" }} onClick={(e) => addChoice()} disabled={isNil(currentSettingsSelection) || isNil(currentPickBan)}>Validate Choice</Button>
            </Grid>


        </Grid>
        }

        <Grid item xs={1} />
        <Grid item container xs={10} component={Paper} padding={"10px"} margin="10px">
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell colSpan={7}><Box component="h2" textAlign={"center"}>Pick and Ban Settings</Box></TableCell>

                    </TableRow>
                    <TableRow>
                        <TableCell width={"30px"}>Turn</TableCell>
                        <TableCell width={"100px"}>Joueur</TableCell>
                        <TableCell width={"100px"}>Pick / Ban</TableCell>
                        <TableCell width={"400px"}>Settings</TableCell>
                        <TableCell>Settings Description</TableCell>
                        <TableCell width={"30px"} />
                        <TableCell width={"400px"}>Seed Generation Check List</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {pickBanList.map((s, i) => {
                        return <TableRow>
                            <TableCell sx={{ fontSize: "24px" }}>#{s.turn}</TableCell>
                            <TableCell sx={{ fontSize: "24px" }}>{s.joueur}</TableCell>
                            <TableCell sx={{ fontSize: "24px" }}>{s.choice}</TableCell>
                            <TableCell sx={{ color: s.choice === "ban" ? "red" : "lightgreen", fontSize: "24px" }}>{s.setting.title}</TableCell>
                            <TableCell sx={{ fontSize: "14px" }}>{s.setting.detail}</TableCell>
                            <TableCell>{i === turn - 2 ? <Button color="error" startIcon={<DeleteIcon />} onClick={() => cancelLastTurn()}> Cancel Turn</Button> : <></>}</TableCell>
                            <TableCell sx={{ fontSize: "14px" }}><ul>
                                {s.choice === "pick" && s.setting.pickSetup?.map((line) => {
                                    return <li>{line}</li>
                                })}
                            </ul>
                            </TableCell>
                        </TableRow>
                    })}
                </TableBody>
            </Table>
        </Grid>

        {!pickBanStart && !isEmpty(pickBanList) && <Grid item xs={12} container>

            <Grid item xs={1} />
            <Grid item container xs={10} component={Paper} padding={"10px"} margin="10px">
                <Table size="small">
                    <TableHead>
                        <TableRow sx={{ backgroundColor: "darkgray" }}>
                            <TableCell colSpan={3}><Box component="h2" textAlign={"center"}>Base Settings</Box></TableCell>
                        </TableRow>
                        <TableRow>

                            <TableCell >Base Settings</TableCell>
                            <TableCell width={"400px"}>Settings Description</TableCell>
                            <TableCell>Cancel by the following settings</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {BaseSettings.map((s, i) => {
                            let settings = pickBanList.filter(x => x.setting.nullifySetting?.some(y => y === s.id) && x.choice === "pick");

                            return <TableRow>
                                <TableCell sx={{ color: !isEmpty(settings) ? "red" : "white", fontSize: "24px" }}>{s.title}</TableCell>
                                <TableCell sx={{ color: !isEmpty(settings) ? "red" : "white", fontSize: "18px" }} >{s.detail}</TableCell>
                                <TableCell sx={{ fontSize: "24px" }}>{settings?.[0]?.setting.title}</TableCell>
                            </TableRow>
                        })}
                    </TableBody>
                </Table>
            </Grid>
            <Grid item xs={1} />
        </Grid>}
        <Grid item xs={1} />



    </Grid >
}
